const generalActions = [
  { label: '导入计算数据源', method: 'showImportDialog', icon: 'el-icon-upload2' },
  { label: '导出费用模板', method: 'handleExportTemplate', icon: 'el-icon-document' },
  { label: '导入费用数据源', method: 'showOtherImportDialog', icon: 'el-icon-upload2' },
  { label: '导出当前明细', method: 'handleExport', icon: 'el-icon-download' },
];
const fullActions = [
  { label: '导入全托数据源', method: 'showImportDialog', icon: 'el-icon-upload2' },
  { label: '导出罚款 / 仓储 / 退款模板', method: 'handleExportTemplate', icon: 'el-icon-document' },
  { label: '导入罚款 / 仓储 / 退款', method: 'showOtherImportDialog', icon: 'el-icon-upload2' },
  { label: '导出当前明细', method: 'handleExport', icon: 'el-icon-download' },
];

/** 仅列出三小龙模块的八类来源，不改变原月报页面或其他平台入口。 */
export const MONTHLY_SOURCES = [
  { key: 'shein-full', code: 'SHEIN_FULL', type: 10, platform: 'Shein', mode: '全托管', dateField: 'date', component: () => import('../sheinFull/sheinFull.vue'), actions: fullActions },
  { key: 'shein-half', code: 'SHEIN_SEMI', type: 11, platform: 'Shein', mode: '半托管', dateField: 'date', component: () => import('../sheinSemi/sheinSemi.vue'), actions: generalActions },
  { key: 'shein-third', code: 'SHEIN_THIRD', type: 12, platform: 'Shein', mode: '第三方', dateField: 'date', component: () => import('../sheinThirdPatry/sheinThirdPatry.vue'), actions: generalActions },
  { key: 'temu-full', code: 'TEMU_FULL', type: 8, platform: 'Temu', mode: '全托管', dateField: 'accountingMonth', component: () => import('../temuFull/temuFull.vue'), actions: [
    { label: '导入主数据', method: 'showImportDialog', args: ['main'], icon: 'el-icon-upload2' },
    { label: '导入罚款', method: 'showImportDialog', args: ['penalty'], icon: 'el-icon-upload2' },
    { label: '导出当前明细', method: 'handleExport', icon: 'el-icon-download' },
    { label: '显示列设置', method: 'openColumnSetting', icon: 'el-icon-setting' },
  ] },
  { key: 'temu-half', code: 'TEMU_SEMI', type: 9, platform: 'Temu', mode: '半托管', dateField: 'accountingMonth', component: () => import('../temuSemiV2/temuSemiV2.vue'), actions: [
    ...generalActions.slice(0, 1),
    { label: '导入 DIY 数据', method: 'showDiyImportDialog', icon: 'el-icon-upload2' },
    ...generalActions.slice(1),
  ] },
  { key: 'tiktok-full', code: 'TIKTOK_FULL', type: 13, platform: 'TikTok', mode: '全托管', dateField: 'date', component: () => import('../tiktokFull/tiktokFull.vue'), actions: fullActions },
  { key: 'tiktok-third', code: 'TIKTOK_THIRD', type: 14, platform: 'TikTok', mode: '第三方', dateField: 'date', component: () => import('../tiktokThirdPatry/tiktokThirdPatry.vue'), actions: generalActions },
  { key: 'walmart', code: 'WALMART', type: 7, platform: 'Walmart', mode: '自运营', dateField: 'date', component: () => import('../walmart/walmartMonthReport.vue'), actions: [
    ...generalActions,
    { label: '刷单费维护', method: 'showBrushingFeeDialog', icon: 'el-icon-money' },
  ] },
];

export const MONTHLY_PLATFORMS = [
  { key: 'Shein', route: 'threeDragonSheinMonthReport', color: '#8e75b0', description: '全托管 / 半托管 / 第三方', defaultSource: 'shein-half' },
  { key: 'Temu', route: 'threeDragonTemuMonthReport', color: '#df8954', description: '全托管 / 半托管', defaultSource: 'temu-full' },
  { key: 'TikTok', route: 'threeDragonTikTokMonthReport', color: '#536176', description: '全托管 / 第三方', defaultSource: 'tiktok-full' },
  { key: 'Walmart', route: 'threeDragonWalmartMonthReport', color: '#5783cf', description: '自运营', defaultSource: 'walmart' },
];

export const SOURCE_CODES = MONTHLY_SOURCES.map(source => source.code);
export const sourcesForPlatform = platform => MONTHLY_SOURCES.filter(source => source.platform === platform);

const SHEIN_SHARED_PAGES = [
  { key: 'primage', label: '运费补贴', route: 'primage', component: () => import('../sheinSemi/primage.vue') },
  { key: 'sfsOrder', label: 'SFS 订单', route: 'sfsOrder', component: () => import('../sheinSemi/sfsOrder.vue') },
];
const SOURCE_PAGES = {
  'shein-half': [...SHEIN_SHARED_PAGES, { key: 'onlinePlaceOrder', label: '在线下单', route: 'onlinePlaceOrder', component: () => import('../sheinSemi/onlinePlaceOrder.vue') }],
  'shein-third': SHEIN_SHARED_PAGES,
  'temu-half': [{ key: 'waybillFee', label: '面单费用', route: 'waybillFee', component: () => import('../temuSemiV2/temuWaybill.vue') }],
  'temu-full': [
    { key: 'temuFullOverdueSkuMapping', label: '超期 SKU 映射', route: 'temuFullOverdueSkuMapping', component: () => import('../temuFull/temuFullOverdueSkuMapping.vue') },
    { key: 'temuFullOverdueSku', label: '超期 SKU 数据', route: 'temuFullOverdueSku', component: () => import('../temuFull/temuFullOverdueSku.vue') },
  ],
  walmart: [
    { key: 'walmartDropShipping', label: '一件代发', route: 'walmartDropShipping', component: () => import('../walmart/walmartDropShipping.vue') },
    { key: 'walmartAdvertisingBill', label: '广告费用', route: 'walmartAdvertisingBill', component: () => import('../walmart/walmartAdvertisingBill.vue') },
  ],
};
export const sourcePages = source => SOURCE_PAGES[source.key] || [];

/** 使用 Vue 的数据合并规则，在原页首次查询前设置月份；原页所有方法和权限保持原样。 */
export function embeddedSourceComponent(source) {
  return () => source.component().then(module => {
    const original = module.default || module;
    return {
    name: `ThreeDragonEmbedded${source.type}`,
    extends: original,
    props: { reportMonth: { type: String, default: '' } },
    data() { return { searchForm: { [source.dateField]: this.reportMonth || null } }; },
    watch: {
      reportMonth(value) {
        if (this.searchForm[source.dateField] === value) return;
        this.searchForm[source.dateField] = value || null;
      },
      [`searchForm.${source.dateField}`](value, previous) {
        this.$emit('report-month-change', value || '');
        if (value && value !== previous) { this.pageNum = 1; this.getPageList(); }
      },
      loading(value, previous) { if (previous && !value) this.$emit('report-refreshed'); },
    },
    methods: {
      getPageList(...args) {
        // 原页重置会清空月份；嵌入时仍维持当前报表月份，避免明细查询全部历史。
        if (!this.searchForm[source.dateField]) this.searchForm[source.dateField] = this.reportMonth || null;
        return original.methods.getPageList.apply(this, args);
      },
    },
  };
  });
}
